import React, { ComponentType } from 'react';

import { GetGroupIconsComponent, GroupIconMap } from 'api';
import { QueryManager } from 'components';

export interface IWithGroupIcons {
  groupIcons: GroupIconMap[];
}

const withGroupIcons = <T extends {}>(Component: ComponentType<T>) => (props: T) => (
  <GetGroupIconsComponent>
    {queryResult => (
      <QueryManager {...queryResult}>
        {() => <Component {...(props as T)} groupIcons={queryResult.data.getGroupIcons} />}
      </QueryManager>
    )}
  </GetGroupIconsComponent>
);

export default withGroupIcons;
